import {useParams} from 'react-router-dom';
import {useAuth} from '../../../../../contexts/auth/context';
import {RemindersRepository} from '../../../../../repositories/reminders';
import {
  RemindersContent,
  RemindersUnavailable,
} from '../../../../../components/reminders-content/reminders-content';

export default function InformalRemindersPage() {
  const {seniorId} = useParams<{seniorId?: string}>();
  const {state} = useAuth();
  const selectedSeniorId = state.session?.selectedRelationship?.withUser?.id;

  if (!seniorId || selectedSeniorId !== seniorId) return <RemindersUnavailable />;

  return <RemindersContent key={seniorId} seniorId={seniorId} api={RemindersRepository.instance} />;
}
